import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { CustomerService } from '../../services/customer.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export async function initList() {
    filter.set({ criteria: { customersOnly: 1, showAll: 0 }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    if (oid == 0) {
        record.set({
            oid: 0,
            name: '',
            street: '',
            civicNumber: '',
            city: '',
            province: '',
            country: '',
            zipCode: '',
            vatNumber: '',
            fiscalCode: '',
            phone1: '',
            phone2: '',
            mobile1: '',
            mobile2: '',
            email: '',
            emailPec: '',
            website: '',
            fixedWeightLoss: 0,
            percWeightLoss: 0,
            hotTransportExecuted: 0,
            hotTransportCooled: 0,
            trc: 0,
            clfPaymentTypeId: null,
            notes: '',
            ownCompany: 0,
            customerFlag: 1,
            carrierFlag: 0,
            supplierFlag: 0,
            deleted: 0
        });
    }
    else {
        let _resp = await CustomerService.fetchCustomer(oid);
        record.set(_resp.payload);
        await loadStats(oid);
    }
}
async function loadStats(counterOid) {
    //let _resp = await CounterService.fetchCounterStats(counterOid);
    //stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await CustomerService.getCustomers(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/customer/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/customer/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await CustomerService.saveCustomer(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await CustomerService.deleteCustomer(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export function onCustomersFilterClick() {
    let f = get(filter);
    f.criteria.customersOnly = 1;
    f.criteria.suppliersOnly = 0;
    f.criteria.carriersOnly = 0;
    filter.set(f);
    search();
}
export function onSuppliersFilterClick() {
    let f = get(filter);
    f.criteria.customersOnly = 0;
    f.criteria.suppliersOnly = 1;
    f.criteria.carriersOnly = 0;
    filter.set(f);
    search();
}
export function onCarriersFilterClick() {
    let f = get(filter);
    f.criteria.customersOnly = 0;
    f.criteria.suppliersOnly = 0;
    f.criteria.carriersOnly = 1;
    filter.set(f);
    search();
}
